export * from "./getters.js";
export * from "./actions.js";
export * from "./mutations";

export const PRODUCTS_M = "PRODUCTS/";

